import * as React from 'react';

// import * as Spinner from 'react-spinkit';			// https://github.com/KyleAMathews/react-spinkit

import './BubbleWrapper.pcss';

export const BubbleWrapper = (props:{show:boolean}) => {
	if(props.show){
		return (
			<div className="bubbleWrapper">
				Spinner
			</div>
		);
	} else {
		return null;
	}
}	
